import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { css } from '@emotion/core';

import { appContainerStyle, clientSmallWrapperStyle } from 'client/styles/common';

import Logout from 'client/components/Logout';

const SignupForm = lazy(() =>
    import(/* webpackChunkName: "ugc_form_signup" */ 'ugc/components/form/SignupForm')
);
const RedeemForm = lazy(() =>
    import(/* webpackChunkName: "ugc_form_redeem" */ 'ugc/components/form/RedeemForm')
);

export default function Form({ match }) {
    return (
        <div css={css(appContainerStyle, clientSmallWrapperStyle)}>
            <Switch>
                <Route path={`${match.path}/signup`} component={SignupForm} />
                <Route
                    path={`${match.path}/redeem/:formId/:prizeUUID/:entriesUUID`}
                    component={RedeemForm}
                />
            </Switch>
            <Logout />
        </div>
    );
}
